<template>
    <div class="wrapper wrapper2">
        <div class="inner">
            <div class="action">
                <UserInfo />
                <div class="btn btn-rule" @click="ruleRef.Show">活动规则</div>
            </div>
        </div>
        <div class="gift gift-1">
            <i v-if="user.team_reward_status > 0"></i>
            <ul>
                <li>
                    <img
                        src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/icons/3.png"
                    />
                    <strong>兄弟情义象征</strong>
                </li>
                <li>
                    <img
                        src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/icons/4.png"
                    /><strong>情义之泉</strong>
                </li>
                <li>
                    <img
                        src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/icons/7.png"
                    /><strong>情义之泉</strong>
                </li>
                <li>
                    <img
                        src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/icons/5.png"
                    /><strong>双倍经验卡(3小时)</strong>
                </li>
                <li>
                    <img
                        src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/icons/6.png"
                    /><strong>魔神双倍经验卡(3小时)</strong>
                </li>
                <li>
                    <img
                        src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/icons/1.png"
                    /><strong>江湖救急包</strong>
                </li>
            </ul>
        </div>
        <div class="gift gift-2">
            <i class="i-2" v-if="user.team_reward_status == 2"></i>
            <ul>
                <li>
                    <img
                        src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/icons/1.png"
                    /><strong>江湖救急包</strong>
                </li>
                <li>
                    <img
                        src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/icons/5.png"
                    /><strong>双倍经验卡(3小时)</strong>
                </li>
                <li>
                    <img
                        src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/icons/6.png"
                    /><strong>魔神双倍经验卡(3小时)</strong>
                </li>
                <li>
                    <img
                        src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/icons/2.png"
                    /><strong>高级聚灵珠</strong>
                </li>
            </ul>
        </div>
        <h3>*道具奖励于开服后前往“天风大陆新区福利使者”处领取</h3>
        <ul class="btns-wrapper">
            <li v-if="!user.cur_team_id" @click="createTeam">我要当团长</li>
            <li v-if="user.cur_team_id" @click="inviteRef.Show">邀请入团</li>
            <li v-if="!user.cur_team_id" @click="joinTeam">加入兄弟团</li>
            <li v-if="user.cur_team_type == 1" @click="disbandTeam">
                解散兄弟团
            </li>
            <li v-if="user.cur_team_type == 2" @click="disbandTeam">
                退出兄弟团
            </li>
        </ul>
        <Teams :inviteFn="inviteFn" />
    </div>
    <Teleport to=".container">
        <RulePop ref="ruleRef" />
        <CreatePop ref="createRef" />
        <AttendPop ref="attendRef" />
        <InvitePop ref="inviteRef" />
        <QuitPop ref="quitRef" />
    </Teleport>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { ref, inject, computed } from "vue";
import useStore from "@/store/store";
import UserInfo from "@/components/user-info.vue";
import RulePop from "./components/pop-rule.vue";
import CreatePop from "./components/pop-create.vue";
import AttendPop from "./components/pop-attend.vue";
import InvitePop from "./components/pop-invite.vue";
import QuitPop from "./components/pop-quit.vue";
import Teams from "./components/teams.vue";
const { user, teams } = storeToRefs(useStore());

const loginRef = inject("loginRef");
const bindRef = inject("bindRef");
const ruleRef = ref(null);
const createRef = ref(null);
const attendRef = ref(null);
const inviteRef = ref(null);
const quitRef = ref(null);

// 创建兄弟团
const createTeam = () => {
    if (!user.value.islogin) {
        return loginRef.value.Show();
    }
    if (!user.value.rolename) {
        return bindRef.value.Show();
    }
    createRef.value.Show();
};

// 解散兄弟团
const disbandTeam = () => {
    quitRef.value.Show();
};

// 邀请
const inviteFn = () => {
    inviteRef.value.Show();
};

// 加入兄弟团
const joinTeam = () => {
    if (!user.value.islogin) {
        return loginRef.value.Show();
    }
    if (!user.value.rolename) {
        return bindRef.value.Show();
    }
    attendRef.value.Show();
};
</script>

<style lang="scss" scoped>
.wrapper2 {
    background-image: url("https://static.web.sdo.com/xyx/pic/act/2026/0902_Join/3.jpg");
    height: 1083px;
    .action {
        position: absolute;
        right: 0px;
        display: flex;
        align-items: center;
        color: #e2a13e;
        top: 300px;
        .btn-rule {
            margin-left: 12px;
            padding: 6px 12px;
            font-size: 14px;
            background-color: #e2a13e;
            color: #462e1f;
            border-radius: 4px;
            cursor: pointer;
            &:hover {
                background-color: #f0b45c;
                color: #462e1f;
            }
        }
    }
    .gift {
        position: absolute;
        top: 410px;
        left: 50%;
        i {
            position: absolute;
            width: 32px;
            height: 32px;
            left: 50%;
            margin-left: 110px;
            top: -50px;
            z-index: 1;
            background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/icon-done.png");
            &.i-2 {
                margin-left: 90px;
            }
        }
        ul {
            display: grid;
            grid-template-columns: repeat(3, 181px);
            grid-template-rows: repeat(2, 88px);
            gap: 16px;
            li {
                background: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/gift-item.png");
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                    top: -7px;
                    position: relative;
                }
                strong {
                    position: absolute;
                    width: 100%;
                    left: 0px;
                    bottom: 6px;
                    color: #e9af52;
                    text-align: center;
                    font-size: 14px;
                }
            }
        }
        &.gift-1 {
            margin-left: -536px;
        }
        &.gift-2 {
            margin-left: 160px;
            ul {
                grid-template-columns: repeat(2, 181px);
            }
        }
    }
    h3 {
        position: absolute;
        top: 630px;
        width: 100%;
        text-align: center;
        left: 0px;
        color: #75482b;
    }
    .btns-wrapper {
        position: absolute;
        width: 100%;
        display: flex;
        bottom: 250px;
        justify-content: center;
        li {
            width: 352px;
            height: 109px;
            line-height: 120px;
            cursor: pointer;
            margin: 0px 30px;
            text-align: center;
            font-size: 32px;
            color: #792520;
            background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/btn-bg.png");
            &:hover {
                background-position: 0px -131px;
            }
        }
    }
}
</style>
